export default __webpack_public_path__ + "media/images/favicon/favicon-16x16-79b25f1cb6c977b65de3e4e032e54e39.png";